module.exports = __webpack_public_path__ + "static/media/social-engineering-darija.e318f9d6.png";